<template>
    <div id="underline-relative">
    <header id="main-header">
        <a class="home-logo" href="/"><Logo /></a>
        <div id="menu-button" @click="handleMenu">
            <svg id="menu-open" xmlns="http://www.w3.org/2000/svg" width="47.504" height="38.203" viewBox="0 0 47.504 38.203">
                <g data-name="Group 8" transform="translate(-505.989 -260.559) rotate(-45)">
                    <rect id="Rct_14" data-name="Rct 14" width="47.504" height="4.203" transform="translate(192.143 590.615) rotate(-135)" fill="#fff"/>
                    <rect id="Rct_15" data-name="Rct 15" width="47.504" height="4.203" transform="translate(180.122 602.635) rotate(-135)" fill="#fff"/>
                    <rect id="Rct_16" data-name="Rct 16" width="47.504" height="4.203" transform="translate(204.163 578.594) rotate(-135)" fill="#fff"/>
                </g>
            </svg>
            <svg id="menu-close" xmlns="http://www.w3.org/2000/svg" width="36.562" height="36.563" viewBox="0 0 36.562 36.563">
                <g data-name="Group 8" transform="translate(-158.552 -554.052)">
                    <rect id="Rct_11" data-name="Rct 11" width="47.504" height="4.203" transform="translate(158.552 587.643) rotate(-45)" fill="#000"/>
                    <rect id="Rct_17" data-name="Rct 17" width="47.504" height="4.203" transform="translate(192.143 590.615) rotate(-135)" fill="#000"/>
                </g>
            </svg>
        </div>
        <div class="mobile-menu-background">
            <ul id="nav">
                <li class="mobile-only"><a href="/">Home</a></li>
                <li v-for="link in links" :key="link.url">
                    <router-link :data-page-id="link.page_id"
                    @click.native="handleRoute"
                    v-bind:to="{ path: link.url }" >{{ link.name }}</router-link>
                </li>
                <li class="mobile-only"><a href="tel:+48570205746">Call</a></li>
                <li class="mobile-only"><a href="mailto:kontakt@modoleandrow8.pl">Email</a></li>
                <li class="mobile-only first-share-link"><a target="_blank" href="https://www.facebook.com/MODOleandrow8">Facebook</a></li>
                <li class="mobile-only"><a target="_blank" href="https://www.instagram.com/modoleandrow8/">Instagram</a></li>
            </ul>
        </div>
        <div id="menu-underline" />
    </header>

    </div>
</template>

<style lang="scss">
    #menu-button {
        width: 48px;
        height: 39px;
        margin: 0 auto;
        padding-top: 37px;
    }

    #menu-close {
        padding-top: 2px;
    }

    #underline-relative {
        position: relative;

        li a {
            position: relative;

            &::after {
                opacity: 0;
                transition: opacity 0.3s;
                content: '';
                display: block;
                position: absolute;
                bottom: -3px;
                left: 0;
                width: 100%;
                border-bottom: 3px solid #fff;
            }


            &:hover::after {
                opacity: 0.5;
            }
        }


        #menu-underline {
            border-bottom: 2px solid #fff;
            position: absolute;
            transition: all 0.5s;
            visibility: visible;
            top: 52px;
            left: 0;
            width: 0;

            .init.page-home & {
                transition: width 0.5s;
            }

            .none & {
                visibility: hidden;
            }
        }



    }

</style>

<script>
    //v-bind:to="{ path: link.url, meta: { userId: '123' } }" >{{ link.name }}</router-link>
    import Logo from './Logo.vue';

    function debounce(func, wait, immediate) {
        let timeout;
        return function() {
            let context = this,
                    args = arguments;
            const later = function() {
                timeout = null;
                if (!immediate) {
                    func.apply(context, args);
                }
            };
            const callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) {
                func.apply(context, args);
            }
        };
    }

    export default
    {
        name: 'Header',
                components: {
        Logo
    },
        data()
        {
            return {
                links: window.APP_INFO.menu_links
            }
        },
        methods: {
            handleWindowResize: debounce(function() {
                this.underlineAnimate(document.querySelector('#nav a.router-link-active'));
            }, 100),
            handleRoute(e) {
                this.$emit('reload',
                    {
                        href: e.target.attributes.href,
                        id: e.target.dataset.pageId
                    }
                );
            },
            handleMenu(e) {
                this.$emit('menu_state_changed', e);
            },
            underlineAnimate($this) {
                if ($this === null) {
                    return;
                }
                const underline = document.getElementById('menu-underline');
                underline.style.width =  $this.offsetWidth + 'px';
                underline.style.transform = 'translate(' + $this.offsetLeft + 'px, 0)'
            }
        },
        mounted: function() {
            const vm = this;
            document.querySelectorAll(`#nav a`).forEach(element => {
                element.addEventListener('click', function() {
                        vm.underlineAnimate(this);
                    });
            });

            window.onresize = vm.handleWindowResize;

            vm.underlineAnimate(document.querySelector('#nav a.router-link-active'));

            setTimeout(function(){
                document.getElementById('menu-underline').style.opacity = 1;
            }, 1500);
        }
    }
</script>